import { createContext } from 'react';

type OccupancyLabels = {
  adultsLabel: string;
  minorsLabel: string;
  infantsLabel: string;
};

type GenericLabels = {
  cabinLabel: string;
};

export const OccupancyLabelsContext = createContext<OccupancyLabels>({
  adultsLabel: '',
  minorsLabel: '',
  infantsLabel: '',
});

export const GenericLabelsContext = createContext<GenericLabels>({ cabinLabel: '' });
